import { id, milestone } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
} from "./assignTag";
import {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
} from "./removeTag";
import {
  handleEditRequest,
  handleEditSuccess,
  handleEditFailure,
} from "./editMilestone";
import { handleMarkMilestoneAsCompleted } from "./markMilestoneAsCompleted";
import { handleMoveListElement } from "./moveListElement";
import { handleConstrainElements } from "./constrainElement";
import { handleEditConstraint } from "./editConstraint";
import { handleEditTask } from "./editTask";

const initialState = { ...milestone, uuid: id };

const reduceMilestone = createStateReducer(initialState, {
  [events.editMilestoneRequested]: handleEditRequest,
  [events.editMilestoneSucceeded]: handleEditSuccess,
  [events.editMilestoneFailed]: handleEditFailure,
  [events.markMilestoneAsCompletedSucceeded]: handleMarkMilestoneAsCompleted,
  [events.assignTagRequested]: handleAssignTagRequest,
  [events.assignTagSucceeded]: handleAssignTagSuccess,
  [events.assignTagFailed]: handleAssignTagFailure,
  [events.removeTagRequested]: handleRemoveTagRequest,
  [events.removeTagSucceeded]: handleRemoveTagSuccess,
  [events.removeTagFailed]: handleRemoveTagFailure,
  [events.moveListElementSucceeded]: handleMoveListElement,
  [events.editTaskSucceeded]: handleEditTask,
  [events.constrainElementsSucceeded]: handleConstrainElements,
  [events.editConstraintSucceeded]: handleEditConstraint,
});

export { reduceMilestone };
